import { BUILD_VERSION } from './version';

export const environment = {
  buildVersion: BUILD_VERSION,
  apiBasePath: 'https://bookingapi.wellext.de/api/v1',
  paypalClientId: 'AVEHapRkk7VM0ELc8D7SrC7tYu13r9tHGR_3jxcji7OcKonZNCKzZkyTplk9FXZeNS9QyvXlATW-r5SV'
};
